import { FC } from 'react'
import { SvgProps } from './svgProps'

const RulerIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || 669}
    height={height || 220}
    viewBox="0 0 669 220"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M631.84 0.320048H37.4933C17.332 0.320048 0.905334 16.7467 0.905334 36.908V183.255C0.905334 203.416 17.332 219.843 37.4933 219.843H631.84C652.001 219.843 668.428 203.416 668.428 183.255L668.423 36.1614C668.423 16 651.996 0.317383 631.835 0.317383L631.84 0.320048ZM647.523 182.507C647.523 190.72 640.804 198.189 631.84 198.189H37.4933C29.2797 198.189 21.8107 191.471 21.8107 182.507V36.16C21.8107 27.9464 28.5295 20.4774 37.4933 20.4774H94.2387V80.212H115.145V20.4774H186.828V80.212H207.735V20.4774H279.417V80.212H300.324V20.4774H372.007V80.212H392.913V20.4774H464.596V80.212H485.503V20.4774H557.185V80.212H578.092V20.4774H632.597C640.811 20.4774 648.28 27.1962 648.28 36.16L648.27 182.507H647.523Z"
      fill={color || '#000'}
    />
  </svg>
)

export default RulerIcon
